import { I18n } from 'lib/i18n'
import { get, post, put } from 'lib/utilities'
import { push } from 'react-router-redux'
import { toast } from 'react-toastify'
import { reset } from 'redux-form'

export const CHECK_EMAIL = 'user/CHECK_EMAIL'
export const CHECK_EMAIL_DONE = 'user/CHECK_EMAIL_DONE'
export const CHECK_EMAIL_FAILED = 'user/CHECK_EMAIL_FAILED'
export const LOGIN = 'user/LOGIN'
export const LOGIN_DONE = 'user/LOGIN_DONE'
export const LOGIN_FAILED = 'user/LOGIN_FAILED'
export const REQUEST_PASSWORD = 'user/REQUEST_PASSWORD'
export const REQUEST_PASSWORD_DONE = 'user/REQUEST_PASSWORD_DONE'
export const REQUEST_PASSWORD_FAILED = 'user/REQUEST_PASSWORD_FAILED'
export const CHANGE_PASSWORD = 'user/CHANGE_PASSWORD'
export const CHANGE_PASSWORD_DONE = 'user/CHANGE_PASSWORD_DONE'
export const CHANGE_PASSWORD_FAILED = 'user/CHANGE_PASSWORD_FAILED'
export const LOGOUT = 'user/LOGOUT'
export const LOGOUT_DONE = 'user/LOGOUT_DONE'
export const LOGOUT_FAILED = 'user/LOGOUT_FAILED'
export const REGISTER = 'user/REGISTER'
export const CREATE = 'user/CREATE'
export const RESET_FORM = 'user/RESET_FORM'
export const LOAD_CURRENT_USER = 'user/LOAD_CURRENT_USER'
export const LOAD_CURRENT_USER_DONE = 'user/LOAD_CURRENT_USER_DONE'
export const LOAD_CURRENT_USER_FAILED = 'user/LOAD_CURRENT_USER_FAILED'

//export const submitLogin = (email, password) =>({type: BLAH});
export const submitEmail = (email) => ({ type: CHECK_EMAIL, email })
export const checkEmailFailed = (errors) => ({
  type: CHECK_EMAIL_FAILED,
  errors,
})

export const submitPassword = (email, password) => ({
  type: LOGIN,
  email,
  password,
})
export const submitRequestPassword = (email) => ({
  type: REQUEST_PASSWORD,
  email,
})
//TODO: change name and parameters
export const submitNewPassword = (serializedForm) => ({
  ...serializedForm,
  type: CHANGE_PASSWORD,
})
export const changePasswordFulfilled = () => ({ type: CHANGE_PASSWORD_DONE })
export const changePasswordFailed = (errors) => ({
  type: CHANGE_PASSWORD_FAILED,
  errors,
})

export const loginUser = (email, password) => ({ type: LOGIN, email, password })
export const loginUserFulfilled = (currentUser) => ({
  type: LOGIN_DONE,
  currentUser,
})
export const loginUserFailed = (errors) => ({ type: LOGIN_FAILED, errors })

export const logoutUser = () => ({ type: LOGOUT })
export const logoutUserFulfilled = () => ({ type: LOGOUT_DONE })

export const registerUser = (email) => ({ type: REGISTER, email })

export const requestNewPassword = (email) => ({ type: REQUEST_PASSWORD, email })
export const requestNewPasswordFulfilled = () => ({
  type: REQUEST_PASSWORD_DONE,
})
export const requestNewPasswordFailed = (errors) => ({
  type: REQUEST_PASSWORD_FAILED,
  errors,
})

export const createUser = (email) => ({ type: CREATE, email })
export const resetForm = () => ({ type: RESET_FORM })

export const loadCurrentUser = () => ({ type: LOAD_CURRENT_USER })
export const loadCurrentUserFulfilled = (currentUser) => ({
  type: LOAD_CURRENT_USER_DONE,
  currentUser,
})
export const loadCurrentUserFailed = () => ({ type: LOAD_CURRENT_USER_FAILED })

const initialState = {
  //  currentUser: {},
  askPass: false,
}

// TODO: @andreas include messages for success
export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_FORM:
      return { ...state, askPass: false }
    case CHECK_EMAIL:
      return { ...state, email: action.email, passwordResetSuccess: false }
    case CHECK_EMAIL_DONE:
      return { ...state, askPass: true }
    case CREATE:
      return { ...state, creating: true }
    case LOGIN:
      return { ...state, loggingIn: true }
    case LOGIN_DONE:
      return { ...state, currentUser: action.currentUser, loggingIn: false }
    case LOGIN_FAILED:
      return { ...state, loggingIn: false, askPass: false }
    case LOGOUT:
      return { ...state, loggingOut: true }
    case LOGOUT_DONE:
      return { ...state, currentUser: {}, loggingOut: false }
    case LOGOUT_FAILED:
      return { ...state, loggingOut: false }
    case REQUEST_PASSWORD:
      return {
        ...state,
        requestingPasswordReset: true,
        firstLogin: action.firstLogin,
        passwordResetSuccess: false,
      }
    case REQUEST_PASSWORD_DONE:
      return {
        ...state,
        requestingPasswordReset: false,
        passwordResetSuccess: true,
      }
    case REQUEST_PASSWORD_FAILED:
      return {
        ...state,
        requestingPasswordReset: false,
        passwordResetSuccess: false,
      }
    case CHANGE_PASSWORD:
      return { ...state, changingPassword: true }
    case CHANGE_PASSWORD_DONE:
      return { ...state, changingPassword: false }
    case CHANGE_PASSWORD_FAILED:
      return { ...state, changingPassword: false }
    case LOAD_CURRENT_USER:
      return { ...state, currentUserLoading: true }
    case LOAD_CURRENT_USER_DONE:
      return {
        ...state,
        currentUserLoading: false,
        currentUser: action.currentUser,
      }
    default:
      return state
  }
}

export const checkEmailEpic = (action$) =>
  action$
    .ofType(CHECK_EMAIL)
    .mergeMap((action) =>
      post('/users/check_mail.json', { user: { email: action.email } })
    )
    .mergeMap((result) => {
      if (result.ok) {
        if (result.body.status === 'first')
          return [
            {
              type: REQUEST_PASSWORD,
              email: result.body.email,
              firstLogin: true,
            },
          ]
        else if (result.body.status === 'continue')
          return [{ type: CHECK_EMAIL_DONE }]
        else {
          toast.error(I18n.t('action.login/CHECK_EMAIL_FAILED'))
          return [checkEmailFailed(result.body.errors)]
        }
      } else {
        toast.error(I18n.t('action.login/CHECK_EMAIL_FAILED'))
        return [checkEmailFailed(result.body.errors)]
      }
    })

export const logoutEpic = (action$) =>
  action$
    .ofType(LOGOUT)
    .mergeMap((action) => post('/users/sign_out.json'))
    .mergeMap(() => {
      //      localStorage.removeItem('userToken');
      return [logoutUserFulfilled()]
    })

export const loginEpic = (action$) =>
  action$
    .ofType(LOGIN)
    .mergeMap((action) =>
      post('/users/sign_in.json', {
        user: { email: action.email, password: action.password },
      })
    )
    .mergeMap((result) => {
      if (result.ok) {
        localStorage.setItem('userToken', result.body.user.token)
        let actions = []
        actions.push(loginUserFulfilled(result.body.user))
        return actions
      } else {
        toast.error(I18n.t('action.login/LOGIN_FAILED'))
        return [loginUserFailed(result.body.errors), reset('login')]
      }
    })

export const requestPasswordEpic = (action$, store) =>
  action$
    .ofType(REQUEST_PASSWORD)
    .mergeMap((action) =>
      post('/users/password.json', { user: { email: action.email } })
    )
    .mergeMap((result) => {
      if (result.ok) return [requestNewPasswordFulfilled()]
      else {
        toast.error(I18n.t('action.login/LOGIN_FAILED'))
        return [requestNewPasswordFailed(result.body.errors)]
      }
    })

export const submitNewPasswordEpic = (action$, store) =>
  action$
    .ofType(CHANGE_PASSWORD)
    .mergeMap((action) =>
      put('/users/password.json', {
        user: {
          password: action.password,
          password_confirmation: action.password_confirmation,
          reset_password_token: action.reset_password_token,
        },
      })
    )
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.user/CHANGE_PASSWORD_DONE'))
        return [push('/'), changePasswordFulfilled(), loadCurrentUser()]
      } else {
        toast.error(I18n.t('action.user/CHANGE_PASSWORD_FAILED'))
        return [changePasswordFailed(result.body.errors)]
      }
    })

export const loadCurrentUserEpic = (action$, store) =>
  action$
    .ofType(LOAD_CURRENT_USER)
    .mergeMap((action) => get('/users/current.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadCurrentUserFulfilled(result.body)]
      } else {
        return [
          loadCurrentUserFulfilled({}),
          //          loadCurrentUserFailed(result.body.errors),
        ]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/user.js